import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    checkbox: {
      padding: 9,
      margin: "6px 8px",
      border: `1px solid ${primary.light}`,
      boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.15)",
      borderRadius: "4px",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "#fff"
      },
      "&.Mui-disabled": {
        opacity: 0.5
      }
    },
    checkboxIcon: {
      display: "flex",
      padding: "8px"
    },
    checkedIconWrapper: {
      display: "flex"
    },
    checkedIcon: {
      width: "16px",
      height: "16px"
    }
  };
});
